import type {
  UseCocoMentionsConfig,
  UseCocoMentionsResult,
} from './use-coco-mentions';
import { useCocoMentions } from './use-coco-mentions';

export type UseAgentMentionsConfig = Omit<
  UseCocoMentionsConfig,
  'excludeAgentTools'
>;

/**
 * @-mentions for the agent instruction editor: same as {@link useCocoMentions}, but
 * user-defined agent tools are not listed under Tools (they stay in the Agents group as resources).
 *
 * Options include a `typeLabel` (Agent, Tool, Folder, …) so the mention menu can show it beside
 * each name in compact rows (for example the search “Suggested” list).
 */
export const useAgentMentions = (
  config?: UseAgentMentionsConfig
): UseCocoMentionsResult => {
  return useCocoMentions({ ...config, excludeAgentTools: true });
};
